export default __webpack_public_path__ + "static/media/12.d9a3360d.png";